<template>
    <iframe :src="iframeSrc" style="height: 100vh; width: 100vw;"></iframe>
</template>

<script>
import homeServices from "@/apiServices/homeServices";
import BookFreeCounselling from "@/components/partials/BookFreeCounselling.vue";
import { DASHBOARD_REGISTER_URL } from "@/config";

import VideoTestimonialSlider from "@/components/partials/VideoTestimonialSlider.vue";
import TextTestimonialSlider from "@/components/partials/TextTestimonialSlider.vue";
import RecentPostSection from "@/components/partials/RecentPostSection.vue";
import ContactusSection from "@/components/partials/ContactusSection.vue";
import { LMS_API } from "@/config/index";
import {
  courseOptions,
  specializationOptions,
} from "../../partials/sefDetails";
import fair1 from "../../../assets/imgs/new_fair/1.png";
import fair2 from "../../../assets/imgs/new_fair/2.png";
import fair3 from "../../../assets/imgs/new_fair/3.png";
import fair4 from "../../../assets/imgs/new_fair/4.png";
import fair5 from "../../../assets/imgs/new_fair/5.png";
import fair6 from "../../../assets/imgs/new_fair/6.png";
import fair7 from "../../../assets/imgs/new_fair/7.png";
import fair8 from "../../../assets/imgs/new_fair/8.png";
import fair9 from "../../../assets/imgs/new_fair/9.png";
import fair10 from "../../../assets/imgs/new_fair/10.png";
import fair11 from "../../../assets/imgs/new_fair/11.png";
import fair12 from "../../../assets/imgs/new_fair/12.png";
import fair13 from "../../../assets/imgs/new_fair/13.png";
import fair14 from "../../../assets/imgs/new_fair/14.png";
import fair15 from "../../../assets/imgs/new_fair/15.png";
import fair16 from "../../../assets/imgs/new_fair/16.png";
import fair17 from "../../../assets/imgs/new_fair/17.png";
import fair18 from "../../../assets/imgs/new_fair/18.png";
import fair19 from "../../../assets/imgs/new_fair/19.png";
import fair20 from "../../../assets/imgs/new_fair/20.png";
import fair21 from "../../../assets/imgs/new_fair/21.png";
import fair22 from "../../../assets/imgs/new_fair/22.png";
import fair23 from "../../../assets/imgs/new_fair/23.png";
import axios from "axios";
import { ref, onMounted, onBeforUnmount } from "vue";


export default {
  components: {
    BookFreeCounselling,
    VideoTestimonialSlider,
    TextTestimonialSlider,
    RecentPostSection,
    ContactusSection,
  },
  data() {
    return {
      iframeSrc: '',

      images: [
        { id: 1, src: fair1 },
        { id: 2, src: fair2 },
        { id: 2, src: fair3 },
        { id: 3, src: fair4 },
        { id: 4, src: fair5 },
        { id: 5, src: fair6 },
        { id: 6, src: fair7 },
        { id: 7, src: fair8 },
        { id: 8, src: fair9 },
        { id: 9, src: fair10 },
        { id: 10, src: fair11 },
        { id: 11, src: fair12 },
        { id: 12, src: fair13 },
        { id: 13, src: fair14 },
        { id: 14, src: fair15 },
        { id: 15, src: fair16 },
        { id: 16, src: fair17 },
        { id: 17, src: fair18 },
        { id: 18, src: fair19 },
        { id: 19, src: fair20 },
        { id: 20, src: fair21 },
        { id: 21, src: fair22 },
        { id: 22, src: fair23 },
      ],
      services_arr: [
        {
          id: 1,
          title: "Undergraduate",
          icon: "fa-solid fa-book-reader",
          description: "Step-by-step support from admission to career start.",
        },
        {
          id: 2,
          title: "Masters/PG",
          icon: "fa-solid fa-book",
          description: "Advance your career with expert guidance.",
        },
        {
          id: 3,
          title: "Diploma",
          icon: "fa-solid fa-school-flag",
          description: "Gain practical skills for immediate career entry.",
        },
        {
          id: 4,
          title: "MBA",
          icon: "fa-solid fa-user-tie",
          description: "Elevate your leadership and business expertise.",
        },
      ],
      badges: [
        {
          id: 2,
          title: "Undergraduate",
          src: `<svg fill="#000000" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="30px" height="30px" viewBox="0 0 477.005 477.005" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <path d="M7.075,204.297l71.191,34.293v57.087c0,4.801,2.75,9.178,7.075,11.262l136.194,65.605c1.692,0.814,3.546,1.237,5.425,1.237 h22.886c1.879,0,3.732-0.423,5.426-1.237l135.817-65.425c2.633-1.27,4.738-3.42,5.95-6.079c0.171-0.375,0.334-0.754,0.497-1.134 c0.663-1.552,1.005-3.223,1.005-4.91v-56.407l19.419-9.354v77.412c-4.202,2.801-7.441,6.998-9.01,12.109l-11.049,36.002 c-1.361,4.44-1.324,9.124,0.109,13.542l10.246,31.578c2.922,9.007,11.245,15.254,20.709,15.545 c0.063,0.002,0.125,0.003,0.188,0.004l0.312,0.005c0.065,0.001,0.13,0.001,0.196,0.001c9.304,0,17.52-5.594,20.931-14.253 l11.847-30.072c1.828-4.637,2.059-9.824,0.65-14.605L452.043,319c-1.539-5.229-4.806-9.522-9.083-12.368v-89.438l26.97-12.992 c4.325-2.084,7.075-6.46,7.075-11.262v-9.955c0-4.801-2.75-9.178-7.075-11.262L243.827,62.81c-3.429-1.651-7.422-1.651-10.85,0 L7.075,171.628C2.75,173.711,0,178.088,0,182.89v10.146C0,197.837,2.75,202.213,7.075,204.297z M429.886,385.539l-7.853-24.202 l8.376-27.295l8.456,28.704L429.886,385.539z M373.54,287.824l-126.548,60.959h-17.179l-126.547-60.959v-37.19l129.712,62.483 c1.714,0.826,3.569,1.238,5.425,1.238s3.71-0.412,5.425-1.238l129.713-62.482L373.54,287.824L373.54,287.824z M238.402,87.946 l207.632,100.017l-63.763,30.715c-0.562,0.178-1.116,0.387-1.656,0.646L238.402,287.83L96.19,219.324 c-0.539-0.259-1.093-0.468-1.654-0.646l-63.764-30.716L238.402,87.946z"></path> </g> </g></svg>`,
        },
        {
          id: 3,
          title: "Postgraduate",
          src: `<svg fill="#000000" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="30px" height="30px" viewBox="0 0 477.005 477.005" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <path d="M7.075,204.297l71.191,34.293v57.087c0,4.801,2.75,9.178,7.075,11.262l136.194,65.605c1.692,0.814,3.546,1.237,5.425,1.237 h22.886c1.879,0,3.732-0.423,5.426-1.237l135.817-65.425c2.633-1.27,4.738-3.42,5.95-6.079c0.171-0.375,0.334-0.754,0.497-1.134 c0.663-1.552,1.005-3.223,1.005-4.91v-56.407l19.419-9.354v77.412c-4.202,2.801-7.441,6.998-9.01,12.109l-11.049,36.002 c-1.361,4.44-1.324,9.124,0.109,13.542l10.246,31.578c2.922,9.007,11.245,15.254,20.709,15.545 c0.063,0.002,0.125,0.003,0.188,0.004l0.312,0.005c0.065,0.001,0.13,0.001,0.196,0.001c9.304,0,17.52-5.594,20.931-14.253 l11.847-30.072c1.828-4.637,2.059-9.824,0.65-14.605L452.043,319c-1.539-5.229-4.806-9.522-9.083-12.368v-89.438l26.97-12.992 c4.325-2.084,7.075-6.46,7.075-11.262v-9.955c0-4.801-2.75-9.178-7.075-11.262L243.827,62.81c-3.429-1.651-7.422-1.651-10.85,0 L7.075,171.628C2.75,173.711,0,178.088,0,182.89v10.146C0,197.837,2.75,202.213,7.075,204.297z M429.886,385.539l-7.853-24.202 l8.376-27.295l8.456,28.704L429.886,385.539z M373.54,287.824l-126.548,60.959h-17.179l-126.547-60.959v-37.19l129.712,62.483 c1.714,0.826,3.569,1.238,5.425,1.238s3.71-0.412,5.425-1.238l129.713-62.482L373.54,287.824L373.54,287.824z M238.402,87.946 l207.632,100.017l-63.763,30.715c-0.562,0.178-1.116,0.387-1.656,0.646L238.402,287.83L96.19,219.324 c-0.539-0.259-1.093-0.468-1.654-0.646l-63.764-30.716L238.402,87.946z"></path> </g> </g></svg>`,
        },
      ],
      pointers: [
        {
          id: 1,
          src: `<svg width="80px" height="80px" viewBox="0 0 1024 1024" fill="#1e00ff" class="icon" version="1.1" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M328.108 580.186c-1.632 0-3.288-0.5-4.708-1.544-82.136-59.95-131.172-156.592-131.172-258.504C192.228 143.818 335.68 0.366 512 0.366c176.312 0 319.772 143.452 319.772 319.772 0 101.904-49.042 198.532-131.188 258.472-3.562 2.624-8.574 1.826-11.18-1.734a8 8 0 0 1 1.746-11.164c78.04-56.958 124.632-148.76 124.632-245.574C815.786 152.63 679.508 16.354 512 16.354c-167.506 0-303.784 136.278-303.784 303.784 0 96.83 46.584 188.638 124.614 245.606a7.99 7.99 0 1 1-4.722 14.442zM951.688 1023.634H72.314a7.992 7.992 0 0 1-7.996-7.994v-111.92c0-68.624 35.544-94.9 101.13-119.416l16.684-6.182c9.462-3.498 20.22-7.462 31.752-11.804 4.106-1.514 8.736 0.532 10.296 4.684a8.02 8.02 0 0 1-4.676 10.306c-11.554 4.34-22.35 8.304-31.836 11.818l-16.628 6.168c-61.47 22.952-90.732 44.438-90.732 104.426v103.926h863.382V903.72c0-59.988-29.258-81.474-90.73-104.426l-18.098-6.712a4272.098 4272.098 0 0 1-29.852-11.086c-4.124-1.546-6.214-6.152-4.688-10.292 1.562-4.136 6.168-6.198 10.308-4.668a6082.09 6082.09 0 0 0 29.758 11.054l18.176 6.712c65.578 24.516 101.114 50.792 101.114 119.416v111.92a7.986 7.986 0 0 1-7.99 7.996z" fill=""></path><path d="M328.132 671.246a7.99 7.99 0 0 1-7.994-7.994v-91.06a7.99 7.99 0 0 1 7.994-7.994 7.99 7.99 0 0 1 7.994 7.994v91.06a7.99 7.99 0 0 1-7.994 7.994zM695.872 671.886a7.99 7.99 0 0 1-7.996-7.996V572.16a7.99 7.99 0 0 1 7.996-7.994 7.988 7.988 0 0 1 7.992 7.994v91.73a7.988 7.988 0 0 1-7.992 7.996z" fill=""></path><path d="M695.872 623.92h-367.74c-4.418 0-7.994-3.576-7.994-7.994s3.576-7.994 7.994-7.994h367.74c4.418 0 7.992 3.576 7.992 7.994s-3.574 7.994-7.992 7.994zM312.136 671.886a8 8 0 0 1-0.312-15.99l399.724-15.988c4.184-0.498 8.118 3.264 8.304 7.682a8.01 8.01 0 0 1-7.68 8.306l-399.708 15.99h-0.328zM280.166 312.142a7.992 7.992 0 0 1-7.996-7.994c0-123.428 100.414-223.84 223.84-223.84a7.99 7.99 0 0 1 7.994 7.994 7.99 7.99 0 0 1-7.994 7.994c-114.614 0-207.852 93.238-207.852 207.852a7.988 7.988 0 0 1-7.992 7.994zM512.008 735.84c-0.492 0-1-0.046-1.508-0.14l-167.88-31.976a7.996 7.996 0 0 1-6.354-9.354 7.972 7.972 0 0 1 9.352-6.354l167.88 31.976a7.996 7.996 0 0 1-1.49 15.848z" fill=""></path><path d="M511.994 735.84a7.998 7.998 0 0 1-1.492-15.848l167.882-31.976c4.418-0.766 8.524 2.044 9.352 6.354a7.994 7.994 0 0 1-6.356 9.354l-167.88 31.976c-0.508 0.092-1.016 0.14-1.506 0.14zM551.972 831.772h-79.944a8.008 8.008 0 0 1-7.15-4.418l-15.988-31.978a7.99 7.99 0 0 1 3.576-10.726 8 8 0 0 1 10.726 3.576l13.78 27.558h70.068l13.77-27.558a8.002 8.002 0 0 1 10.726-3.576 8 8 0 0 1 3.578 10.726l-15.988 31.978a8.02 8.02 0 0 1-7.154 4.418z" fill=""></path><path d="M456.04 911.714c-0.992 0-1.998-0.188-2.966-0.562a8.014 8.014 0 0 1-4.458-10.398l31.976-79.944c1.632-4.108 6.34-6.106 10.392-4.464a8.014 8.014 0 0 1 4.458 10.398l-31.978 79.944a8.004 8.004 0 0 1-7.424 5.026zM567.96 911.714a8.02 8.02 0 0 1-7.434-5.028l-31.976-79.944c-1.632-4.092 0.376-8.744 4.464-10.398 4.062-1.624 8.762 0.358 10.398 4.464l31.98 79.944a8.038 8.038 0 0 1-4.468 10.398 8.096 8.096 0 0 1-2.964 0.564zM425.25 991.658a8 8 0 0 1-5.076-1.812l-97.124-79.944a8.024 8.024 0 0 1-2.498-8.71l14.262-42.784-91.748-76.446a8.014 8.014 0 0 1-1.124-11.148l63.954-79.944c2.764-3.418 7.784-4.012 11.242-1.248a8.008 8.008 0 0 1 1.25 11.242l-59.06 73.822L349.24 849.6a8.018 8.018 0 0 1 2.458 8.684l-14.248 42.75 92.886 76.446a8.026 8.026 0 0 1 1.092 11.274 8.018 8.018 0 0 1-6.178 2.904z" fill=""></path><path d="M472.036 991.658a7.976 7.976 0 0 1-6.994-4.124L305.156 699.74c-2.146-3.84-0.756-8.712 3.108-10.868a7.996 7.996 0 0 1 10.868 3.124l159.886 287.794c2.146 3.842 0.756 8.712-3.108 10.868-1.228 0.688-2.562 1-3.874 1zM598.75 991.658c-2.308 0-4.59-1-6.184-2.904a8.04 8.04 0 0 1 1.094-11.274l92.886-76.446-14.254-42.75a8.044 8.044 0 0 1 2.464-8.684l89.906-74.914-59.05-73.822a8.018 8.018 0 0 1 1.25-11.242 7.988 7.988 0 0 1 11.238 1.248l63.958 79.944a8.02 8.02 0 0 1-1.124 11.148l-91.746 76.446 14.27 42.784a8.062 8.062 0 0 1-2.496 8.71l-97.122 79.944a8.028 8.028 0 0 1-5.09 1.812z" fill=""></path><path d="M551.972 991.658a7.852 7.852 0 0 1-3.872-1 7.996 7.996 0 0 1-3.124-10.868l159.886-287.794c2.156-3.872 7.028-5.262 10.868-3.124 3.872 2.154 5.262 7.028 3.122 10.868l-159.882 287.794a7.996 7.996 0 0 1-6.998 4.124zM408.084 799.794a7.96 7.96 0 0 1-6.816-3.81 7.996 7.996 0 0 1 2.616-10.992l103.926-63.954a7.996 7.996 0 0 1 8.382 13.614l-103.924 63.956a7.91 7.91 0 0 1-4.184 1.186z" fill=""></path><path d="M615.926 799.794a7.882 7.882 0 0 1-4.184-1.188l-103.934-63.956a7.996 7.996 0 0 1 8.384-13.614l103.918 63.954a7.986 7.986 0 0 1 2.624 10.992 7.93 7.93 0 0 1-6.808 3.812zM512 991.658a7.99 7.99 0 0 1-7.996-7.994v-111.922a7.988 7.988 0 0 1 7.996-7.992 7.992 7.992 0 0 1 7.996 7.992v111.922a7.992 7.992 0 0 1-7.996 7.994zM472.028 591.944a7.99 7.99 0 0 1-7.994-7.994v-63.956a7.99 7.99 0 0 1 7.994-7.994 7.99 7.99 0 0 1 7.996 7.994v63.956a7.99 7.99 0 0 1-7.996 7.994zM551.972 591.944a7.992 7.992 0 0 1-7.996-7.994v-63.956c0-4.418 3.578-7.994 7.996-7.994s7.992 3.576 7.992 7.994v63.956a7.988 7.988 0 0 1-7.992 7.994z" fill=""></path><path d="M472.036 527.988a8.01 8.01 0 0 1-6.252-2.998 8.006 8.006 0 0 1 1.25-11.242l39.972-31.976c3.458-2.764 8.472-2.178 11.242 1.25a8.004 8.004 0 0 1-1.25 11.242l-39.97 31.978a7.992 7.992 0 0 1-4.992 1.746z" fill=""></path><path d="M551.972 527.988a7.974 7.974 0 0 1-4.996-1.748l-39.972-31.978a8.01 8.01 0 0 1-1.25-11.242c2.772-3.412 7.792-4.004 11.242-1.25l39.972 31.976a8.024 8.024 0 0 1 1.25 11.242 8.016 8.016 0 0 1-6.246 3zM551.972 480.024a7.992 7.992 0 0 1-7.996-7.996V344.12c0-4.418 3.578-7.994 7.996-7.994s7.992 3.576 7.992 7.994v127.91a7.988 7.988 0 0 1-7.992 7.994zM472.028 480.024a7.99 7.99 0 0 1-7.994-7.996V344.12a7.99 7.99 0 0 1 7.994-7.994 7.99 7.99 0 0 1 7.996 7.994v127.91a7.99 7.99 0 0 1-7.996 7.994z" fill=""></path><path d="M432.058 392.086c-26.45 0-47.966-21.516-47.966-47.966 0-26.45 21.516-47.964 47.966-47.964 26.45 0 47.966 21.516 47.966 47.964a7.99 7.99 0 0 1-7.996 7.996 7.99 7.99 0 0 1-7.994-7.996c0-17.634-14.34-31.976-31.976-31.976s-31.978 14.342-31.978 31.976c0 17.636 14.34 31.978 31.978 31.978a7.99 7.99 0 0 1 7.994 7.996 7.99 7.99 0 0 1-7.994 7.992zM591.946 392.086a7.99 7.99 0 0 1-7.996-7.994 7.99 7.99 0 0 1 7.996-7.996c17.64 0 31.976-14.34 31.976-31.978 0-17.634-14.336-31.976-31.976-31.976-17.644 0-31.98 14.342-31.98 31.976 0 4.42-3.574 7.996-7.992 7.996s-7.996-3.576-7.996-7.996c0-26.45 21.516-47.964 47.968-47.964 26.45 0 47.964 21.516 47.964 47.964 0 26.452-21.516 47.968-47.964 47.968z" fill=""></path><path d="M591.946 392.086h-7.996a7.992 7.992 0 0 1-7.996-7.994 7.992 7.992 0 0 1 7.996-7.996h7.996a7.988 7.988 0 0 1 7.992 7.996 7.988 7.988 0 0 1-7.992 7.994z" fill=""></path><path d="M440.052 392.086h-7.994a7.99 7.99 0 0 1-7.994-7.994 7.99 7.99 0 0 1 7.994-7.996h7.994a7.99 7.99 0 0 1 7.994 7.996 7.99 7.99 0 0 1-7.994 7.994z" fill=""></path><path d="M519.996 392.086h-15.99a7.99 7.99 0 0 1-7.994-7.994 7.99 7.99 0 0 1 7.994-7.996h15.99a7.988 7.988 0 0 1 7.992 7.996 7.988 7.988 0 0 1-7.992 7.994z" fill=""></path></g></svg>`,
          title: "16+",
          para: "Years of experience",
        },
        {
          id: 2,
          src: `<svg fill="#1e00ff" width="80px" height="80px" viewBox="0 0 36 36" version="1.1" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" stroke="#2800f0" stroke-width="0.00036"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>success-standard-line</title> <path class="clr-i-outline clr-i-outline-path-1" d="M18,2A16,16,0,1,0,34,18,16,16,0,0,0,18,2Zm0,30A14,14,0,1,1,32,18,14,14,0,0,1,18,32Z"></path><path class="clr-i-outline clr-i-outline-path-2" d="M28,12.1a1,1,0,0,0-1.41,0L15.49,23.15l-6-6A1,1,0,0,0,8,18.53L15.49,26,28,13.52A1,1,0,0,0,28,12.1Z"></path> <rect x="0" y="0" width="36" height="36" fill-opacity="0"></rect> </g></svg>`,
          title: "99%",
          para: "Admission Succcess Rate",
        },
        {
          id: 3,
          src: `<svg fill="#1e00ff" height="80px" width="80px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 455 455" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <path d="M342.337,98.9c-0.031-0.037-0.057-0.076-0.09-0.113c-0.445-0.504-0.946-0.926-1.481-1.281 C310.441,71.049,270.811,55,227.5,55c-43.311,0-82.941,16.049-113.267,42.507c-0.534,0.355-1.035,0.777-1.48,1.281 c-0.032,0.036-0.058,0.076-0.09,0.113C77.301,130.512,55,176.447,55,227.5s22.301,96.988,57.663,128.6 c0.031,0.037,0.057,0.076,0.09,0.113c0.445,0.504,0.946,0.926,1.481,1.281C144.559,383.951,184.189,400,227.5,400 c43.315,0,82.948-16.052,113.275-42.514c0.531-0.354,1.03-0.773,1.472-1.274c0.032-0.036,0.058-0.076,0.09-0.113 C377.699,324.488,400,278.553,400,227.5S377.699,130.512,342.337,98.9z M317.414,220c-0.668-30.652-5.424-59.891-13.748-85.227 c11.587-5.705,22.562-12.728,32.7-20.984c28.267,27.073,46.489,64.55,48.452,106.211H317.414z M292.544,107.473 c-6.292-12.584-13.44-23.061-21.223-31.264c19.702,5.716,37.826,15.18,53.54,27.573c-8.261,6.504-17.104,12.129-26.39,16.819 C296.621,116.06,294.646,111.676,292.544,107.473z M284.769,126.718c-15.803,6.169-32.597,9.785-49.769,10.601V70.822 c16.318,3.553,31.764,18.631,44.128,43.36C281.13,118.186,283.009,122.374,284.769,126.718z M156.528,120.602 c-9.286-4.69-18.129-10.315-26.39-16.819c15.714-12.393,33.838-21.857,53.54-27.573c-7.783,8.202-14.931,18.68-21.223,31.264 C160.354,111.676,158.379,116.06,156.528,120.602z M175.872,114.182c12.364-24.729,27.81-39.807,44.128-43.36v66.497 c-17.171-0.816-33.966-4.432-49.769-10.601C171.991,122.374,173.87,118.186,175.872,114.182z M220,152.334V220h-67.412 c0.647-28.536,4.981-55.668,12.54-79.172C182.553,147.586,201.072,151.512,220,152.334z M220,235v67.666 c-18.928,0.821-37.447,4.748-54.873,11.506c-7.559-23.505-11.893-50.636-12.54-79.172H220z M220,317.681v66.497 c-16.318-3.553-31.764-18.631-44.128-43.36c-2.002-4.005-3.881-8.192-5.641-12.536C186.034,322.113,202.829,318.497,220,317.681z M162.456,347.527c6.292,12.584,13.44,23.061,21.223,31.264c-19.702-5.716-37.826-15.18-53.54-27.573 c8.261-6.504,17.104-12.129,26.39-16.819C158.379,338.94,160.354,343.324,162.456,347.527z M298.472,334.398 c9.286,4.69,18.129,10.315,26.39,16.819c-15.714,12.393-33.838,21.857-53.54,27.573c7.783-8.202,14.931-18.68,21.223-31.264 C294.646,343.324,296.621,338.94,298.472,334.398z M279.128,340.818c-12.364,24.729-27.81,39.807-44.128,43.36v-66.497 c17.171,0.816,33.966,4.432,49.769,10.601C283.009,332.626,281.13,336.814,279.128,340.818z M235,302.666V235h67.412 c-0.647,28.536-4.981,55.667-12.54,79.172C272.447,307.414,253.928,303.488,235,302.666z M235,220v-67.666 c18.928-0.821,37.447-4.748,54.873-11.506c7.559,23.505,11.893,50.636,12.54,79.172H235z M118.635,113.789 c10.138,8.256,21.113,15.279,32.7,20.984c-8.324,25.336-13.08,54.575-13.748,85.227H70.183 C72.146,178.339,90.368,140.862,118.635,113.789z M70.183,235h67.403c0.668,30.652,5.424,59.891,13.748,85.227 c-11.587,5.705-22.562,12.728-32.7,20.984C90.368,314.138,72.146,276.661,70.183,235z M336.365,341.211 c-10.138-8.256-21.113-15.279-32.7-20.984c8.324-25.336,13.08-54.575,13.748-85.227h67.403 C382.854,276.661,364.632,314.138,336.365,341.211z"></path> <path d="M390.54,382.565c-0.004-0.057-0.003-0.114-0.008-0.171c-0.025-0.279-0.066-0.557-0.122-0.833 c-0.011-0.053-0.027-0.105-0.039-0.159c-0.051-0.223-0.111-0.444-0.182-0.663c-0.024-0.072-0.05-0.144-0.075-0.215 c-0.073-0.204-0.156-0.405-0.248-0.604c-0.03-0.064-0.058-0.129-0.089-0.192c-0.115-0.231-0.241-0.458-0.382-0.679 c-0.014-0.022-0.026-0.046-0.04-0.068c-0.158-0.242-0.331-0.477-0.52-0.704c-0.009-0.011-0.016-0.024-0.026-0.035 c-0.037-0.044-0.079-0.08-0.117-0.123c-0.106-0.121-0.209-0.244-0.325-0.36c-0.039-0.039-0.081-0.071-0.121-0.109 c-0.072-0.069-0.146-0.133-0.22-0.199c-0.149-0.132-0.302-0.257-0.458-0.376c-0.069-0.052-0.138-0.104-0.209-0.154 c-0.192-0.135-0.389-0.259-0.591-0.373c-0.041-0.023-0.079-0.049-0.12-0.071c-0.512-0.279-1.05-0.493-1.602-0.643 c-0.058-0.016-0.117-0.028-0.176-0.043c-0.217-0.053-0.435-0.098-0.654-0.132c-0.077-0.012-0.153-0.024-0.23-0.033 c-0.227-0.028-0.454-0.045-0.682-0.052c-0.057-0.002-0.114-0.008-0.172-0.008c-0.283-0.002-0.565,0.011-0.847,0.04 c-0.015,0.002-0.03,0-0.045,0.002l-36.67,4.055c-4.117,0.455-7.085,4.162-6.63,8.279c0.456,4.117,4.17,7.087,8.279,6.63 l13.469-1.489C277.318,460.242,154.62,455.141,77.24,377.76C37.104,337.624,15,284.261,15,227.5c0-4.142-3.358-7.5-7.5-7.5 S0,223.358,0,227.5c0,60.767,23.664,117.897,66.633,160.866S166.733,455,227.5,455c51.836,0,101.016-17.231,141.027-48.963 l-3.022,10.329c-1.163,3.976,1.117,8.142,5.092,9.305c0.704,0.206,1.413,0.304,2.11,0.304c3.246,0,6.237-2.124,7.195-5.396 l10.345-35.356c0.005-0.018,0.01-0.035,0.015-0.053l0,0l0-0.001c0.079-0.27,0.138-0.544,0.186-0.82 c0.014-0.083,0.024-0.166,0.036-0.249c0.028-0.199,0.048-0.398,0.059-0.598c0.005-0.091,0.011-0.182,0.013-0.273 C390.561,383.007,390.554,382.786,390.54,382.565z"></path> <path d="M388.367,66.633C345.397,23.664,288.267,0,227.5,0C175.664,0,126.484,17.231,86.473,48.963l3.022-10.329 c1.163-3.976-1.117-8.142-5.092-9.305c-3.978-1.162-8.142,1.117-9.305,5.092L64.754,69.777c-0.005,0.018-0.01,0.035-0.015,0.053 l0,0l0,0.001c-0.079,0.27-0.138,0.544-0.186,0.82c-0.014,0.083-0.024,0.166-0.036,0.249c-0.028,0.199-0.048,0.399-0.059,0.599 c-0.005,0.091-0.011,0.181-0.013,0.272c-0.005,0.222,0.001,0.443,0.016,0.664c0.004,0.057,0.003,0.114,0.008,0.171 c0.025,0.279,0.066,0.557,0.122,0.832c0.011,0.054,0.027,0.106,0.039,0.159c0.05,0.223,0.111,0.444,0.182,0.662 c0.024,0.073,0.05,0.144,0.076,0.216c0.073,0.204,0.156,0.405,0.248,0.603c0.03,0.064,0.057,0.128,0.089,0.191 c0.115,0.231,0.241,0.458,0.381,0.678c0.014,0.023,0.026,0.047,0.041,0.07c0.158,0.242,0.331,0.477,0.52,0.704 c0.009,0.011,0.016,0.024,0.026,0.035c0.05,0.06,0.108,0.112,0.16,0.17c0.094,0.104,0.182,0.212,0.282,0.312 c0.022,0.022,0.047,0.041,0.07,0.063c0.078,0.076,0.161,0.146,0.242,0.219c0.12,0.107,0.239,0.213,0.364,0.311 c0.079,0.062,0.16,0.119,0.241,0.177c0.137,0.099,0.275,0.195,0.416,0.283c0.077,0.048,0.155,0.093,0.234,0.138 c0.152,0.087,0.305,0.17,0.461,0.246c0.078,0.038,0.157,0.074,0.237,0.11c0.16,0.071,0.322,0.135,0.486,0.195 c0.083,0.03,0.165,0.06,0.249,0.087c0.164,0.053,0.33,0.098,0.497,0.139c0.087,0.022,0.173,0.045,0.261,0.064 c0.173,0.036,0.348,0.063,0.523,0.087c0.083,0.011,0.164,0.027,0.248,0.036c0.243,0.025,0.488,0.039,0.732,0.04 c0.014,0,0.027,0.002,0.04,0.002c0.009,0,0.018-0.001,0.027-0.001c0.25-0.001,0.5-0.016,0.75-0.041 c0.016-0.002,0.032-0.001,0.049-0.003l36.67-4.055c4.117-0.455,7.085-4.162,6.63-8.279c-0.456-4.117-4.167-7.079-8.279-6.63 l-13.469,1.489C177.682-5.242,300.38-0.141,377.76,77.24c40.136,40.136,62.24,93.5,62.24,150.26c0,4.142,3.358,7.5,7.5,7.5 s7.5-3.358,7.5-7.5C455,166.732,431.336,109.603,388.367,66.633z"></path> </g> </g></svg>`,
          title: "20+",
          para: "Easy-access Countries",
        },
        {
          id: 4,
          src: `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="80px" height="80px" viewBox="0 0 37 32" enable-background="new 0 0 37 32" xml:space="preserve" fill="#1e00ff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <path fill="#1e00ff" d="M36.078,7.173L19.876,0.346c-0.865-0.365-1.858-0.365-2.728,0L0.922,7.183C0.362,7.42,0.009,7.944,0,8.554 c-0.009,0.607,0.329,1.143,0.881,1.394L2.59,10.73C2.538,10.809,2.5,10.898,2.5,11v9c0,0.005,0.003,0.01,0.003,0.016 c-1.172,0.207-2.066,1.226-2.066,2.456c0,1.111,0.733,2.043,1.736,2.368l-1.798,4.164c-0.271,0.629-0.206,1.326,0.18,1.912 C1.002,31.595,1.787,32,2.656,32l0.289-0.014c0.813-0.066,1.539-0.481,1.941-1.111c0.344-0.537,0.418-1.182,0.203-1.767 L3.541,24.89c1.086-0.272,1.896-1.248,1.896-2.418c0-1.188-0.833-2.18-1.945-2.433C3.493,20.025,3.5,20.014,3.5,20v-8.853l4,1.833 V20h0.01c0.103,2.257,5.827,3.439,11.49,3.439S30.387,22.257,30.49,20h0.01v-7.551l5.607-2.507C36.664,9.694,37.006,9.16,37,8.549 C36.993,7.938,36.641,7.41,36.078,7.173z M4.045,30.336c-0.235,0.368-0.677,0.613-1.186,0.654L2.656,31 c-0.531,0-1.005-0.236-1.266-0.634c-0.2-0.304-0.234-0.647-0.097-0.966l1.533-3.552l1.323,3.604 C4.259,29.746,4.221,30.061,4.045,30.336z M4.438,22.472c0,0.827-0.673,1.5-1.5,1.5s-1.5-0.673-1.5-1.5s0.673-1.5,1.5-1.5 S4.438,21.645,4.438,22.472z M29.5,18.419c-1.898-1.305-6.219-1.98-10.5-1.98s-8.602,0.675-10.5,1.98v-7.278 c0-1.097,3.185-2.641,10.266-2.641c7.004,0,10.734,1.57,10.734,2.703V18.419z M19,22.439c-6.409,0-10.5-1.48-10.5-2.5 s4.091-2.5,10.5-2.5s10.5,1.48,10.5,2.5S25.409,22.439,19,22.439z M35.699,9.03L30.5,11.354v-0.151 c0-2.181-4.825-3.703-11.734-3.703C11.922,7.5,7.5,8.929,7.5,11.141v0.741L1.297,9.038C1.017,8.911,0.999,8.646,1,8.567 s0.027-0.343,0.311-0.463l16.227-6.837c0.619-0.263,1.331-0.261,1.95,0l16.202,6.827c0.285,0.12,0.31,0.386,0.311,0.464 C36.001,8.638,35.981,8.903,35.699,9.03z"></path> </g> </g></svg>`,
          title: "₹28Cr+",
          para: "Million Worth of Scholarships Awarded",
        },
      ],
      service: [],
      form: {
        name: "",
        email: "",
        mobileNumber: "",
        state: null,
        city: null,
        course: null,
        discipline: null,
        interestedCountry: "",
        highestQualification: "",
        budget: "",
        referralSource: "",
      },
      isSubmitting: false,
      showPlan: false,
      DASHBOARD_REGISTER_URL,
      search_tags: [
        "USA",
        "UK",
        "Canada",
        "Ireland",
        "Switzerland",
        "Hungary",
        "France",
        "Germany",
        "Dubai",
        "Monaco",
        "New Zealand",
        "Spain",
      ],
      videoSlider: {
        //autoplay: true,
        //autoplaySpeed: 2500,
        arrows: false,
        dots: true,
        infinite: false,
        slidesToScroll: 1,
        slidesToShow: 2.5,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1.5,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      },
      pricingSlider: {
        //autoplay: true,
        //autoplaySpeed: 2500,
        arrows: false,
        dots: false,
        infinite: false,
        slidesToScroll: 1,
        slidesToShow: 3,
        responsive: [
          {
            breakpoint: 1300,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1.5,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      },

      postSlider: {
        //autoplay: true,
        //autoplaySpeed: 2500,
        arrows: true,
        dots: false,
        infinite: false,
        slidesToScroll: 1,
        slidesToShow: 3,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              arrows: false,
              dots: true,
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      },
      logoSlider: {
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: 1000,
        speed: 3000,
        pauseOnHover: true,
        cssEase: "linear",
        centerMode: true,
        centerPadding: "30px",
        adaptiveHeight: false,
        responsive: [
          // {
          //   breakpoint: 1024,
          //   settings: {
          //     slidesToShow: 4,
          //     slidesToScroll: 1
          //   }
          // },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
        ],
      },
      courseOptions,
      specializationOptions,
      cityOptions: [],
      myStates: [],
      referralOptions: [
        { value: "Aliff Website", text: "Aliff Website" },
        { value: "Social Media", text: "Social Media" },
        { value: "Newspaper Ad", text: "Newspaper Ad" },
        { value: "Friends & Family", text: "Friends & Family" },
        { value: "School/College Visit", text: "School/College Visit" },
        { value: "Radio Ad", text: "Radio Ad" },
      ],
    };
  },
  created() {
    const queryString = window.location.search;
    // this.iframeSrc = `/aliff/fair.html${queryString}`;
    this.iframeSrc = `../../../../fair_page/fair.html${queryString}`;
  },
  props: {
    medium: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    stateOptions() {
      return stateCity.map((stateCity) => stateCity.state);
    },
    async getMyStates() {
      try {
        const res = await axios.get(LMS_API + "/form-webhook/master/states");
        this.myStates = res.data.data.map((state) => ({
          value: state.state_id,
          text: state.name,
        }));
      } catch (error) {
        console.log(error);
      }
    },
    async handleStateChange() {
      try {
        // Make an API call to fetch cities based on the selected state_id
        const response = await axios.get(
          LMS_API + `/form-webhook/master/cities/${this.form.state}`
        );
        this.cityOptions = response.data.data.map((city) => ({
          value: city.city_id,
          text: city.name,
        }));
      } catch (error) {
        console.error("Error fetching cities:", error);
      }
    },
    geCityOptions() {
      let currentStateCity = stateCity.find(
        (stateCity) => stateCity.state === this.form.state
      );

      this.cityOptions = currentStateCity.cities;
    },
    clickShowPlan() {
      this.showPlan = !this.showPlan;
    },
    async handleSubmit(e) {
      try {
        e.preventDefault();

        const requestData = {
          full_name: this.form.name,
          email: this.form.email,
          dial_code_id: "12183",
          country_dial_code: "+91",
          mobile: this.form.mobileNumber,
          field_values: [
            { name: "Budget", value: this.form.budget },
            {
              name: "Highest Qualification",
              value: this.form.highestQualification,
            },
            { name: "Expected Salary", value: this.form.course },
            { name: "Discipline", value: this.form.discipline },
            { name: "Interested Country", value: this.form.interestedCountry },
            { name: "Interested Course", value: this.form.course },
            {
              name: "How did you hear about Aliff Event?",
              value: this.form.referralSource,
            },
          ],
          state: this.form.state,
          city: this.form.city,
          category: "Student",
          ls_id: 80,
        };

        const response = await axios.post(
          `${LMS_API}/form-webhook/lead`,
          requestData
        );
        if (response.data.status) {
          this.isSubmitting = true;
          this.resetForm();
          this.formSubmitToast();
        }
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    },
    addCommas(amt) {
      return amt.toLocaleString("en-IN");
    },
    formSubmitToast() {
      this.$bvToast.toast(`The form has been submitted successfully.`, {
        title: "Form Submitted",
        autoHideDelay: 5000,
        solid: true,
      });
    },
    resetForm() {
      this.form = {
        name: "",
        email: "",
        mobileNumber: "",
        state: null,
        city: null,
        course: null,
        specialization: null,
        interestedCountry: "",
        highestQualification: "",
        budget: "",
        referralSource: "",
      };
    },
  },
  beforeMount() {
    this.getMyStates();
  },
};
</script>


<!-- <style>
.form-label-fair {
  font-size: 18px !important;
}

.floating-icon-box {
  position: absolute;
  top: -20px;
  left: -10px;
  background: aliceblue;
  padding: 12px;
  border-radius: 50%;
}
.floating-icon-box__ {
  position: absolute;
  /* top: -20px;
  left: -10px; */
  background: aliceblue;
  padding: 12px;
  border-radius: 50%;
}

.fair-logo-top {
  position: absolute;
  top: 10px;
  left: 15px;
}

.study-abroad-fair--footer {
  background: rgba(83, 103, 255, 0.05);
}

.video-wrapper {
  max-width: 950px;
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.video-element {
  width: 100%;
  height: auto;
  border-radius: 15px;
}

.main-title::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: -10px;
  /* height: 1px; */
  width: 100px;
  border: 2px solid rgb(254, 109, 1);
  border-radius: 20px;
}

.badge-box {
  padding: 13px 15px;
  border-radius: 10px;
  background-color: aliceblue;
}

.event-details {
  /* display: flex; */
  justify-content: center;
  margin-top: 40px;
}

.event-details img {
  width: 50px;
}

.event-details div {
  display: flex;
  align-items: center;
}

.form-card {
  /* background: white; */
  background: linear-gradient(135deg, #5367ff 0%, #00d09c 100%);

  box-shadow: 0 10px 20px rgb(40 111 219 / 30%);
  border-radius: 10px;
  padding: 41px;
}

.fair-hero-img img {
  width: 100% !important;
  /* margin-top: -15%; */
}

.fair-logos-section img {
  width: 165px;
  height: 80px;
  object-fit: contain;
}

.card-fair-box {
  border: 2px dashed #e9eef4;
  border-radius: 10px;
}

.my-input {
  margin-bottom: 1.7rem;
}

.my-form {
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
}

.fair-img img {
  width: 260px !important;
}

.fair-list li {
  margin-bottom: 0 !important;
}

.fair-hero-img-hero {
  height: 400px;
}

@media screen and (max-width: 768px) {
  .logo-uni {
    overflow-x: hidden;
  }

  .cards-row-fair {
    flex-direction: column !important;
  }

  .when-and-where {
    gap: 20px !important;
    align-items: start !important;
  }
}

.first_column_first_div {
  padding: 15px 5px;
  /* border: 1px solid #e9eef4; */
}

h1 {
  font-size: clamp(1.25rem, 2.5vw, 3rem);
}

h4 {
  font-size: clamp(1.1rem, 2.2vw, 1.6rem);
}

h5 {
  font-size: clamp(0.9rem, 1.8vw, 1.3rem);
}

p {
  font-size: clamp(0.8rem, 1.5vw, 1.2rem);
}

@media screen and (max-width: 768px) {
  .main-heading-1-gradient {
    text-align: center;
  }
  .form-logo {
    display: none;
  }
}
</style> -->






// WEBPACK FOOTER //
// src/components/pages/ChennaiFair/CoimbatoreFair2.vue